import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import FindRepForm from './FindRepForm';

import {
    AnimationContainer,
    Container as BaseContainer,
    Body as BaseBody
} from '../Shared/PopupModalStyles';

const Container = styled(BaseContainer)`
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = styled(BaseBody)`
    padding: 25px 20px;
`;

const RepEmailRedirectPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <FindRepForm
                    isDoubleCheckRepPopup={true}
                    submitting={props.isSubmitting}
                    formattedReps={props.formattedReps}
                    onBack={props.toggleDoubleCheckRepPopup}
                    isLocalRepLoading={props.isLocalRepLoading}
                    imgSources={props.imgSources}
                    handleSubmit={props.onSubmit}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

RepEmailRedirectPopup.propTypes = {
    formattedReps: PropTypes.string,
    toggleDoubleCheckRepPopup: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    imgSources: PropTypes.array.isRequired,
    isLocalRepLoading: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool
};

export default RepEmailRedirectPopup;
